import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body, Container, H5, Page } from '@ui';
import { useNavigate } from 'react-router';
import { scrollToTop } from '@utils/usefulFuncs';
import { ROUTES } from '@constants/routes';
import { TemplateProcessorTool } from '@features/rfp/TemplateProcessorTool';
import { DOCUMENT_SELECTION_MODES } from '@/features/document/DocumentSelectionModal/modes';
import { AI_TOOLS, DOCUMENT_TEMPLATE_MODE_IDS } from '@/constants';

const PageWrapper = styled.div`
  + div {
    width: 100%;
  }
`;

const modeContext = {
  tool: AI_TOOLS.DDQ_TEMPLATE,
  modeType: DOCUMENT_TEMPLATE_MODE_IDS.ddq_template,
  autoSelectDefaultDocuments: true,
  documentSelectionModes: [DOCUMENT_SELECTION_MODES.myDocs],
  defaultActiveDocumentSelectionMode: DOCUMENT_SELECTION_MODES.myDocs,
};

export function RfpTemplateProcessor() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={'1000px'}>
          <Container top={40}>
            <H5>RFP Template Processor</H5>
          </Container>
          <Container top={24}>
            <TemplateProcessorTool onGoBack={onGoBack} modeContext={modeContext} />
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}
